var MessageTcc = {
  NavabarText: {
    navbar_home: "首頁",
    navbar_about: "關於熵達",    
    navbar_product:"產品中心",
    navbar_academic_trends: "學術動態",
    navbar_contact: "聯絡我們",
    navbar_item: "企業社會責任",
    navbar_item_story:'責任故事',
    support_part:'拥党爱党',
    navbr_new: '新聞資訊',
    navbr_join:'招賢納士',
    
    navbr_child_about_1:'公司介紹',
    navbr_child_about_2:'資質榮譽',
    navbr_child_about_3:'企業文化',
    navbr_child_about_5:'文化標語',
    navbr_child_about_4:'發展之路',

    navbr_child_news_1:'公司資訊',
    navbr_child_news_2:'行業動態',

    navbr_child_case_1:'學術直播',
    navbr_child_case_2:'經典視頻',
    navbr_child_case_3:'學術沙龍會',

    navbr_child_join_1:'人才理念',
    navbr_child_join_2:'人才招聘',
    navbr_child_join_3:'職業發展',
    product_introduct:'產品介紹',
    navbr_new_one:'新聞資訊',
    
    company_introduct:'公司簡介',
    company_team:'公司團隊',
    company_person:'人文關懷',
    company_env:'公司環境',
    team_culture:'團隊文化',
    team_culture_desc:'八小時之內求生存，八小時之外求發展',
    company_culture_title:'企業理念：',
    company_culture_desc:'講誠信、講原則、講效率、懂感恩。',
    company_news:'公司資訊',
    navbr_item_desc:'熵達在長期的社會責任管理與實踐中，有意識地將承擔歷史使命、履行社會責任和推動企業可持續發展有機統一，逐步形成了具有自身特色的社會責任管理模式——使命引領型社會責任管理。 該模式涵蓋了責任文化、責任管理、責任踐行等子模塊，明確了熵達開展社會責任工作的目標、指導思想、履責領域、組織動力和工作路徑，是熵達推進社會責任工作的總體思路和行動路線。',

    join_us:'加入我們',

    contact_us_desc:'熵達不忘初心，一直秉持著“為健康生活助力”的使命砥礪前行',
    salon_one:'“卓粵南醫”首届胃腸腫瘤精准微創外科大會（簽到留影）',
    salon_two:'2024南醫外科新啟航會議（第四届）',
    salon_three:'2024年度國家重點研發計畫項目推進會“國產創新醫用電動吻合器應用示範研究',
    salon_four:'廣東省普外（胃腸）專業品質控制中心年度工作例會',
    salon_five:'廣東省醫學會微創外科學分會年會暨第一届青年醫師胃腸微創手術視頻大賽',
    salon_six:'廣州市高新技術（精准微創微創外科科技2023D-ZD01）推廣會暨南方校友論壇',
    company_culture_desc_1:'八小時之內求生存，八小時之外求發展',
    company_culture_desc_2:'過度學習，過度訓練自己',
    company_culture_desc_3:'業績做不好，證明自己還不够努力',
    company_culture_desc_4:'講誠信、講原則、講規矩、講效率',
    company_culture_desc_5:'目標、想法、行動',
    company_culture_desc_6:'過去、現在、未來',
    company_culture_desc_7:'忠心人品大於能力',
    company_culture_desc_8:'用感恩充實你的思想，讓行動實踐你的感恩',
    company_culture_desc_9:'一次性把事情做好',
    company_culture_desc_10:'贏在責任心，勝在執行力',
  },
  About_Navbar: {
    Company: '公司簡介',
    Horor: '榮譽與資質',
    Technology: '科研技術',
    Team: '我們的團隊 ',
    introduct:'廣州市熵達貿易有限公司，是一家經營銷售醫療器械、設備、耗材等產品及產研轉化為一體的公司。 公司以豐富的產品、專業的技術服務、完善的售後服務及產研的專業化服務於各大三甲醫院、門診及其他醫療機構，為其提供完善的醫療產品服務解決方案，產品類型涵蓋所有醫院外科系統（手術室、婦產科、泌尿科、兒科、肛腸科、乳腺科、胃腸科、胸外科、肝膽科等等）。',
    team_desc:'公司以服務第一、誠信經營，合作共贏為宗旨； 年輕而富有朝氣的銷售團隊擁有本科及以上學歷，具有醫學、藥學、企業管理等多學科專業人才； 致力於在醫療市場中以高效、專業、奮進、務實的團隊勠力同心服務一個客戶，優秀的員工隊伍為熵達的快速發展奠定了堅實的基礎，力爭成為行業中的佼佼者。',
    eve:'溫馨的工作環境、和諧的工作氛圍有利於促進人際關係的和諧，激發員工的上進心，提高工作效率，促進了企業的發展。',
    eve_person:'在[熵達]，我們以人文關懷為覈心，打造溫暖成長之家。 我們給員工提供：帶薪旅遊、員工父母關懷、下午茶、季度團建、健康運動、生日福利、年假、年度體檢、入職禮包、周年禮包、良好的培訓機制、師徒帶教機制. …..',
    eve_person_1:'通過四季更迭的團隊活動、專屬定制的星光日、詩意棲息的旅行體驗以及孝心接力的親情關懷，我們讓每一位夥伴在歡笑與成長中感受歸屬。 無論是戶外拓展的默契合作，還是生日驚喜的獨特時刻，亦或是山水間的滋養與探索，我們用心編織情感網絡，將關懷延伸至員工的家人，讓溫暖雙向流動。 在這裡，企業不僅是事業的平臺，更是情感的港灣，我們以真心換真心，讓每個奮鬥的身影在溫暖中堅定前行，共同創造更大價值。',
  
  },
  New_NavBar: {
    Notice: '公司通告',
    MediaCentre: '媒體中心',
  },
  indexText: {
    more: "更多",

    

  },
  footText: {
    companys: '廣州市熵達貿易有限公司',
    address: "地址:廣州市白雲區",
    addresss: '廣州市白雲區',
    phone: "電話",
    email: "電郵",
    address_s: "地址",
    weixin: "掃碼關注公眾號",
    aboutUs: '關於我們',
    company: '公司',
    honor: '榮譽與資質',
    technology: '科研技術',
    team: '我們的團隊 ',
    services: '服務項目',
    news: '最新消息',
    notice: '公司通告',
    mediaCentre: '媒體中心',
    report: '查詢報告',
    contact: '聯絡我們',
    talentRecruitment: '人才招聘',
    OfficeHours: '營業時間',
    day1: '星期一至五',
    day2: '星期六至日',
    version: '版權所有 © 廣州市熵達貿易有限公司 2021-2022',
    back: '返回首頁',
  },
  
  ContractText:{
    termsofuse:'版權所有 © 廣州市熵達貿易有限公司 2021-2022',
  },
  HomeText: {
   
  },
  AboutUs: {
    h_c: '關於我們',
  
   
  },
  concat: {
    h_t: '聯絡我們',
    form_t: '期望與您聯繫',
    ph_1: '給我們意見',
    name: '請輸入您的名字',
    phone:'請輸入您的電話',
    need:'請輸入您的需求',
    codemsg:'請輸入驗證碼',
    ph_3: '電話',
    ph_4: '郵箱',
    sub_t: '提交',
    location: '廣州市白雲區京溪街沙太路668號之二4樓403A房'
  },
  VideoText:{
    video_one_abstract:'腹腔鏡右半結腸癌根治術',
    video_one_date:'2021-06-22',
    video_one_desc:'腹腔鏡右半結腸癌根治術適應於治療橫結腸左半、結腸肝曲、升結腸及闌尾等惡性腫瘤。 腹腔鏡手術因創傷小、恢復快等多種優勢在結直腸癌手術中應用越來越普及，多個臨床研究證實，CME理論指導下的右半結直腸癌根治術可以得到最大程度的淋巴結清掃範圍，並且降低局部復發喝遠處轉移風險，延長總生存。',
    video_two_abstract:'腹腔鏡胃癌根治術',
    video_two_date:'2018-02-11',
    video_two_desc:'腹腔鏡胃癌根治術是借助腹腔鏡科技對患者進行胃癌根治。 在臍部做一個1釐米的孔，放置穿刺裝置，然後注入二氧化碳氣體，使腹部隆起，通過穿刺裝置放入照相機，可以觀察整個腹腔。 左、右上腹部各設0.5 × 1.5cm孔，各2孔。 將穿刺裝置置入超聲刀和鉗子內操作，切斷胃周圍血管，清掃胃周圍淋巴結，上腹部小口約10cm，切除胃及周圍大網膜淋巴結，行消化道吻合術，腔鏡微創手術創傷較小，手術後恢復也比較快，是現時常用的手術方法之一。',
    
    },

    productIntroduct:{
      product_desc:'熵達矢志投身於醫療行業的產品研發生產、醫療器械銷售、醫療行業文化服務等領域，以豐富的產品、專業的技術服務、完善的售後服務於各大三甲醫院、門診及其他醫療機構，為其提供完善的醫療產品服務解決方案，產品類型涵蓋手術室、婦產科、泌尿科、兒科、 肛腸科、乳腺科、胃腸科等外科系統。',
      product_one:'包皮槍',
      product_two:'一次性使用腔鏡直線切割閉合器',
      product_three:'微創筋膜閉合器(微抓鉗minilap)',
    },
  
    honor:{
      start:'初創業',
      item_1:'2014年：公司成立',
      item_2:'2015年：首次與醫療產品生產商簽署合作',
      item_3:'2016年：與多家行業領先醫療產品公司達成合作',
      item_4:'2017年：業務範圍擴大並覆蓋服務於多家大三甲醫院',
      item_5:'2018年：成為多個品牌產品的廣東省總代理並與多產品平臺建立合作',
      item_6:'2019年：開創專利研發項目，孵化自身產品品牌，服務面向全國市場',      
      item_7:'2020年：搭建學術資源平臺，優化戰畧發展架構。 奠定集團化發展方向',      
      item_8:'2021年：獲得2021年度“守合同重信用企業”榮譽稱號，設備得標三家大三甲醫院',
      end:'艱苦奮鬥',
    },
    corporate:{

      item_1:'企業使命',      
      item_1_desc:'為健康生活助力',      
      item_2:'企業願景',      
      item_2_desc:'成為健康產業的引導者',      
      item_3:'企業精神',      
      item_3_desc:'以誠信贏得信賴，以細節決定成敗',      
      item_4:'企業口號',      
      item_4_desc:'努力工作，健康生活，團結友愛，共創佳績',

    },
    concept:{
      item_1:'秉持“為健康生活助力”初心使命，把熵達打造成一個海納百川的組織，在這個組織裏，普通的人變成優秀的人，優秀的人變成卓越的人，源源不斷的人在這裡實現自己的人生夢想。',      
      item_2:'培養和造就一支贏得市場領先、創造組織優勢、引領價值導向、有使命感與責任感的人才隊伍，支持戰略目標的實現，是熵達持續不斷的人才追求。',      
      item_3:'熵達從生活、情感、成長環節關愛員工。',      
      item_4:'熵達人珍視自己內心的夢想和追求，因為有夢想才更加有活力、更加有創造力、更加有超越其他組織和個人的推動力，實現自我境界的昇華。',      
      item_5:'人才管理從戰畧和組織發展需求出發，圍繞熵達人才隊伍建設，針對不同人才群體形成差异化的管理系統，構成人才標準、規劃、選拔、培養、使用和保留的管理閉環。',      
      item_6:'熵達推動關鍵崗位員工進行多崗位、跨職能、跨行業歷練，不斷優化人與崗位、人與團隊、人與組織的匹配度，完善人才隊伍的結構和水准，保持組織的激情與活力。',      
    },
    postData:{
      name:'姓名',      
      name_placeholder:'請填寫姓名',      
      phone:'聯繫方式',      
      phone_placeholder:'請填寫聯繫方式',  
      post:'應聘崗位',      
      post_placeholder:'請選擇應聘崗位',
      submit:'提交信息' ,     
    },

};
export {
  MessageTcc
}



// WEBPACK FOOTER //
// ./src/i18n/lang/tcc.js